import Cookies from 'js-cookie'

const TokenKey = 'teacher-Token'
const StatusKey = 'user-status'
const TokenExpires = 0.5 // token失效时间12小时，已天为单位

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: TokenExpires })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getStatus() {
  return Cookies.get(StatusKey)
}
export function setStatus(status) {
  return Cookies.set(StatusKey, status)
}
export function removeStatus() {
  return Cookies.remove(StatusKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js